import React from 'react';

const ScoreCBw = (props) => (
    <svg viewBox="0 0 59.53 59.53" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient
          id="C_bw_svg__a"
          x1={210.64}
          y1={29.76}
          x2={-148.48}
          y2={29.76}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#222" />
          <stop offset={1} stopColor="#ababab" />
        </linearGradient>
      </defs>
      <g data-name="Vrstva 2">
        <circle
          cx={29.76}
          cy={29.76}
          r={29.76}
          style={{
            fill: "url(#C_bw_svg__a)",
          }}
        />
        <path
          d="M23 42.61a13.86 13.86 0 0 1-5.44-5.16 14.2 14.2 0 0 1-2-7.46 14.22 14.22 0 0 1 2-7.46A13.86 13.86 0 0 1 23 17.37a16.18 16.18 0 0 1 7.78-1.86 16.36 16.36 0 0 1 6.58 1.28 13.22 13.22 0 0 1 4.94 3.68l-4.16 3.84a9 9 0 0 0-7-3.28 9.36 9.36 0 0 0-4.64 1.14 8.1 8.1 0 0 0-3.18 3.18A9.36 9.36 0 0 0 22.14 30a9.33 9.33 0 0 0 1.14 4.64 8.1 8.1 0 0 0 3.18 3.18A9.36 9.36 0 0 0 31.1 39a8.88 8.88 0 0 0 7-3.32l4.16 3.84a12.9 12.9 0 0 1-5 3.72 16.33 16.33 0 0 1-6.6 1.28A16.1 16.1 0 0 1 23 42.61Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </svg>
  );
  
  export default ScoreCBw;